<template>
  <table>
    <caption>대상자상세_기억검사결과</caption>
    <thead class="table_list_head table_list_head_line">
      <tr>
        <th class="center">Round</th>
        <th class="center">회차</th>
        <th class="center sorting" data-sort="useDate">수행일자</th>
        <th class="center">기억건강 단계</th>
        <th class="center">정답수</th>
        <th class="center">1번</th>
        <th class="center">2번</th>
        <th class="center">3번</th>
        <th class="center">4번</th>
        <th class="center">5번</th>
        <th class="center">6번</th>
        <th class="center">7번</th>
        <th class="center">8번</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="rowData in sourceList">
        <td class="right">{{rowData.round}}</td>
        <td class="right">{{rowData.order}}</td>
        <td class="right">{{rowData.useDate}}</td>
        <td class="right">{{rowData.status}}</td>
        <td class="right">{{rowData.correctCount}}</td>
        <td class="right">{{rowData.number1}}</td>
        <td class="right">{{rowData.number2}}</td>
        <td class="right">{{rowData.number3}}</td>
        <td class="right">{{rowData.number4}}</td>
        <td class="right">{{rowData.number5}}</td>
        <td class="right">{{rowData.number6}}</td>
        <td class="right">{{rowData.number7}}</td>
        <td class="right">{{rowData.number8}}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    sourceList: Array
  }
};
</script>

<style>
</style>